import React from "react";

const DelayTillDate = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2220_5683)">
      <rect x="4" y="4" width="24" height="24" rx="4" fill="#FFE4E6" />
    </g>
    <path
      d="M13.168 18.9486C13.168 19.2046 13.3728 19.4094 13.6288 19.4094H16.0992C16.0864 19.2686 16.1119 19.115 16.1632 18.9742L16.368 18.5006L13.6288 18.5005C13.3728 18.4878 13.168 18.7054 13.168 18.9486L13.168 18.9486Z"
      fill="#961B01"
    />
    <path
      d="M19.262 20.2159C19.262 20.4718 19.0572 20.6767 18.8012 20.6767H12.3244C12.0685 20.6767 11.8636 20.4719 11.8636 20.2159V11.7935C11.8636 11.5375 12.0685 11.3327 12.3244 11.3327H18.814C19.07 11.3327 19.2748 11.5375 19.2748 11.7935V15.4287L20.1964 14.6479V11.7935C20.1964 11.0383 19.5821 10.4238 18.8268 10.4238H12.3244C11.5692 10.4238 10.9547 11.0382 10.9547 11.7935V12.2799L10.3788 12.2798C10.1228 12.2798 9.91797 12.4846 9.91797 12.7406V13.3678C9.91797 13.6238 10.1228 13.8286 10.3788 13.8286H10.9547V15.2366H10.3788C10.1228 15.2366 9.91797 15.4414 9.91797 15.6974V16.3246C9.91797 16.5806 10.1228 16.7854 10.3788 16.7854H10.9547V18.1806H10.3788C10.1228 18.1806 9.91797 18.3854 9.91797 18.6414V19.2686C9.91797 19.5246 10.1228 19.7294 10.3788 19.7294H10.9547V20.2158C10.9547 20.971 11.5691 21.5855 12.3244 21.5855L18.814 21.5854C19.5692 21.5854 20.1836 20.971 20.1836 20.2157V18.6798L19.262 19.4606V20.2159Z"
      fill="#961B01"
    />
    <path
      d="M17.2285 18.3593L16.8445 19.2552C16.7677 19.4217 16.9213 19.6009 17.1005 19.5625L18.0477 19.3321C18.2269 19.2809 18.3933 19.2041 18.5469 19.0889L17.5356 17.8984C17.4077 18.0392 17.2924 18.1929 17.2285 18.3592L17.2285 18.3593Z"
      fill="#961B01"
    />
    <path
      d="M21.9643 15.5309L21.5803 15.0829C21.4011 14.8653 21.0811 14.8397 20.8635 15.0317L18.0859 17.4125L19.1227 18.6285L21.9131 16.2477C22.1179 16.0685 22.1436 15.7485 21.9644 15.5309L21.9643 15.5309Z"
      fill="#961B01"
    />
    <path
      d="M17.7915 14.5187L17.2027 14.4547C17.1771 14.4547 17.1643 14.4419 17.1515 14.4163C17.1259 14.3523 17.1004 14.2883 17.0747 14.2243C17.062 14.1987 17.062 14.1859 17.0747 14.1603L17.4588 13.6995C17.5228 13.6227 17.5099 13.5203 17.446 13.4435L17.0876 13.0851C17.0236 13.0211 16.9084 13.0083 16.8316 13.0724L16.3708 13.4564C16.358 13.4692 16.3324 13.4692 16.3068 13.4692C16.2428 13.4435 16.1788 13.4051 16.1148 13.3924C16.0892 13.3796 16.0764 13.3667 16.0764 13.3412L16.0124 12.7524C15.9996 12.6627 15.9228 12.5859 15.8205 12.5859H15.3085C15.2189 12.5859 15.1293 12.6627 15.1165 12.7524L15.0525 13.3412C15.0525 13.3668 15.0397 13.3796 15.0141 13.3924C14.9501 13.418 14.8861 13.4435 14.8222 13.4692C14.7965 13.4819 14.7838 13.4819 14.7581 13.4564L14.2973 13.0724C14.2206 13.0083 14.1181 13.0212 14.0414 13.0851L13.6956 13.4563C13.6315 13.5203 13.6188 13.6355 13.6828 13.7123L14.0668 14.1731C14.0796 14.1858 14.0796 14.2115 14.0668 14.2371C14.0412 14.3011 14.0028 14.3651 13.99 14.429C13.9773 14.4547 13.9644 14.4674 13.9389 14.4674L13.35 14.5315C13.2604 14.5442 13.1836 14.6211 13.1836 14.7234V15.2354C13.1836 15.325 13.2604 15.4146 13.35 15.4273L13.9389 15.4914C13.9645 15.4914 13.9773 15.5041 13.99 15.5298C14.0157 15.5938 14.0412 15.6578 14.0668 15.7217C14.0796 15.7473 14.0796 15.7601 14.0668 15.7857L13.6828 16.2465C13.6188 16.3233 13.6316 16.4257 13.6956 16.5025L14.054 16.8609C14.118 16.9249 14.2332 16.9377 14.3099 16.8737L14.7707 16.4897C14.7835 16.4769 14.8091 16.4769 14.8348 16.4769C14.8988 16.5025 14.9628 16.5409 15.0267 16.5537C15.0523 16.5664 15.0651 16.5793 15.0651 16.6048L15.1291 17.1937C15.1419 17.2833 15.2188 17.3601 15.3211 17.3601H15.833C15.9227 17.3601 16.0122 17.2833 16.025 17.1937L16.089 16.6048C16.089 16.5792 16.1018 16.5664 16.1274 16.5537C16.1914 16.528 16.2555 16.5025 16.3194 16.4769C16.345 16.4641 16.3578 16.4641 16.3834 16.4897L16.8442 16.8737C16.921 16.9377 17.0234 16.9248 17.1002 16.8609L17.4586 16.5025C17.5226 16.4385 17.5354 16.3233 17.4713 16.2465L17.0873 15.7857C17.0746 15.773 17.0746 15.7473 17.0873 15.7217C17.113 15.6577 17.1513 15.5937 17.1641 15.5298C17.1769 15.5041 17.1897 15.4914 17.2153 15.4914L17.8041 15.4273C17.8938 15.4146 17.9705 15.3377 17.9705 15.2354V14.7234C17.958 14.6083 17.8939 14.5315 17.7915 14.5187L17.7915 14.5187ZM15.5771 15.8755C15.0652 15.8755 14.6555 15.4658 14.6555 14.9539C14.6555 14.4419 15.0652 14.0323 15.5771 14.0323C16.0891 14.0323 16.4987 14.4419 16.4987 14.9539C16.4987 15.4659 16.0763 15.8755 15.5771 15.8755Z"
      fill="#961B01"
    />
    <defs>
      <filter
        id="filter0_d_2220_5683"
        x="0"
        y="0"
        width="32"
        height="32"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2220_5683"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2220_5683"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default DelayTillDate;
